module.exports = __webpack_public_path__ + "static/media/about-us-background.e5d556be.jpg";